import { Reveal } from "../landing/Reveal";
import { scrollToId } from "../landing/Navbar";

const REVENUE = [
  { emoji: "🍔", label: "Food", note: "Kitchen commissions" },
  { emoji: "📚", label: "Learning", note: "Courses & certifications" },
  { emoji: "💼", label: "Recruitment", note: "Hiring success fees" },
  { emoji: "🛍", label: "Commerce", note: "Marketplace margin" },
  { emoji: "✈️", label: "Travel", note: "Package partnerships" },
  { emoji: "🌾", label: "Organic", note: "Farm produce network" },
];

export const BiteInvestors = () => (
  <section id="investors" data-testid="bite-investors" className="relative overflow-hidden py-20 sm:py-24">
    <div aria-hidden="true" className="absolute -left-32 top-1/3 h-[380px] w-[380px] rounded-full bg-[#7C3AED]/12 blur-[130px]" />
    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal>
        <p className="font-jbmono text-xs uppercase tracking-[0.3em] text-[#06B6D4]">Investors</p>
        <h2 className="mt-3 max-w-2xl font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl">
          Six revenue engines. One compounding network.
        </h2>
        <p className="mt-4 max-w-xl text-base leading-relaxed text-slate-400">
          Every Bite monetizes natively — and each new student makes all six engines stronger.
        </p>
      </Reveal>

      <div className="mt-12 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
        {REVENUE.map((r, i) => (
          <Reveal key={r.label} delay={0.05 * i} className="h-full">
            <div
              data-testid={`revenue-${r.label.toLowerCase()}`}
              className="flex h-full flex-col items-center rounded-3xl border border-white/10 bg-white/[0.04] p-6 text-center backdrop-blur-xl transition-all duration-300 hover:-translate-y-1.5 hover:border-[#22C55E]/50"
            >
              <span className="text-4xl">{r.emoji}</span>
              <p className="mt-3 font-display text-base font-bold text-white">{r.label}</p>
              <p className="mt-1 text-[11px] leading-snug text-slate-500">{r.note}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2} className="mt-10 text-center">
        <button
          data-testid="bite-investor-cta"
          onClick={scrollToId("#claim")}
          className="glow-btn-b rounded-full bg-gradient-to-r from-[#7C3AED] to-[#06B6D4] px-9 py-4 font-display text-sm font-bold uppercase tracking-wider text-white"
        >
          Request the Deck
        </button>
        <p className="mt-4 font-jbmono text-[10px] uppercase tracking-widest text-slate-600">
          Illustrative business model for demo purposes
        </p>
      </Reveal>
    </div>
  </section>
);
